import React from 'react';
import remoteFiles from '../../common/remote_files';

const conceptPlan = {
  id: 1,
  title: (<>Unlimited Individual</>),
  price: (<>$13.99/mo*</>),
  note: (<>Ideal for the single user.</>),
  description: (<p>Sign up to get unlimited storage for your phone, computer and tablet</p>),
  bestValue: true
};

const bauPlans = [
  {
    id: 1,
    title: (<>Unlimited Individual</>),
    price: (<><b>$13.99</b>/mo*</>),
    note: (<>Ideal for a single user.</>),
    description: (<p>Provides unlimited storage for your phone, computer and tablet.</p>),
    bestValue: false
  },
  {
    id: 2,
    title: (<>Unlimited Group</>),
    price: (<><b>$19.99</b>/mo*</>),
    note: (<>Best value for multiple users.</>),
    description: (<>
      <p>
        Invite up to 4 members to join your plan, each gets their own unlimited storage plan
        {' '}
        for their phone, computer, and tablet.
      </p>
      <p>30 days on us for first-time users. $19.99/mo after.*</p>
    </>),
    bestValue: true
  },
  {
    id: 3,
    title: (<>600 GB</>),
    price: (<><b>$5.99</b>/mo*</>),
    note: (<>Storage for 1 user on a single device.</>),
    description: (<>
      <p>30 days on us for first time users. $5.99/mo after.*</p>
    </>),
    bestValue: false
  },
  {
    id: 4,
    title: (<>Contacts only</>),
    price: (<><b>Free</b></>),
    note: (<></>),
    description: (<>
      <p>
        Back up your contacts for free on one smartphone.
        { ' ' }
        You will not be signed up for a paid Cloud plan.
      </p>
    </>),
    bestValue: false
  }
];

const conceptListPlans = [
  {
    id: 2,
    title: (<>Unlimited<br />Group</>),
    price: (<>$19.99/mo*</>),
    description: (<>
      <p>
        Invite up to 4 members to join your plan, each gets their own unlimited storage plan
        {' '}
        for their phone, computer, and tablet.
      </p>
      <b>Best value for multiple users.</b>
      <p>30 days on us for first-time users. $19.99/mo after.*</p>
    </>)
  },
  {
    id: 3,
    title: (<>600 GB</>),
    price: (<>$5.99/mo*</>),
    description: (<>
      <b>Storage for 1 user on a single device.</b>
      <p>30 days on us for first time users. $5.99/mo after.*</p>
    </>)
  },
  {
    id: 4,
    title: (<>Contacts<br />only</>),
    price: (<>Free</>),
    description: (<>
      <p>
        Back up your contacts for free on one smartphone.
        { ' ' }
        You will not be signed up for a paid Cloud plan.
      </p>
    </>)
  }
];

const phonesImage = remoteFiles.verizon.dynamicOffer.conceptCarousel.phonesImage;
const conceptCarouselPlans = [
  {
    id: 2,
    title: (<>Unlimited<br />Group</>),
    price: (<>$19.99/mo*</>),
    promotion: (<>30 days on us for first time users</>),
    features: [
      {
        icon: 'people',
        className: '-top',
        description: (<>
          Best value for multiple users.<br />
          Invite up to 4 members, each gets their own unlimited plan
        </>)
      },
      {
        icon: 'phones',
        image: phonesImage,
        description: (<>
          Unlimited storage for phone, laptop, tablet
        </>)
      },
      {
        icon: 'lock',
        description: (<>
          Locked Folder
        </>)
      }
    ]
  },
  {
    id: 3,
    title: (<>600 GB</>),
    price: (<>$5.99/mo*</>),
    promotion: (<>30 days on us for first time users</>),
    features: [
      {
        icon: 'people',
        className: '-top',
        description: (<>
          Storage for 1 user on a single device
        </>)
      },
      {
        icon: 'phones',
        image: phonesImage,
        description: (<>
          Back up photos, videos and files to your phone
        </>)
      },
      {
        icon: 'lock',
        description: (<>
          Locked Folder
        </>)
      }
    ]
  },
  {
    id: 4,
    title: (<>Contacts<br />only</>),
    price: (<>Free</>),
    features: [
      {
        icon: 'phones',
        image: phonesImage,
        description: (<>
          Back up your contacts for free on one smartphone.
          { ' ' }
          You will not be signed up for a paid Cloud plan.
        </>)
      }
    ]
  }
];

const mainPlans = {
  concept_carousel: conceptPlan,
  concept_list: conceptPlan
};

const plans = {
  bau: bauPlans,
  bau_image: bauPlans,
  concept_carousel: conceptCarouselPlans,
  concept_list: conceptListPlans
};

const mainPlan = (conceptName) => (mainPlans[conceptName]);
const plansList = (conceptName) => (plans[conceptName]);

export { mainPlan, plansList };
